module.exports = {
      id: "info-fill-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#info-fill-usage",
      toString: function () {
        return this.url;
      }
    }